var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15223_11922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 5.33357V8.6669C10.6667 9.19734 10.8774 9.70605 11.2524 10.0811C11.6275 10.4562 12.1362 10.6669 12.6667 10.6669C13.1971 10.6669 13.7058 10.4562 14.0809 10.0811C14.4559 9.70605 14.6667 9.19734 14.6667 8.6669V8.00024C14.6666 6.49559 14.1575 5.03522 13.2222 3.85659C12.2869 2.67796 10.9804 1.85039 9.51508 1.50844C8.0498 1.16648 6.51194 1.33027 5.15155 1.97315C3.79116 2.61603 2.68825 3.70021 2.02216 5.04939C1.35606 6.39856 1.16596 7.9334 1.48276 9.40431C1.79957 10.8752 2.60464 12.1957 3.76707 13.1511C4.92951 14.1064 6.38094 14.6405 7.88537 14.6663C9.38979 14.6922 10.8587 14.2084 12.0533 13.2936M10.6667 8.00024C10.6667 9.473 9.47275 10.6669 7.99999 10.6669C6.52723 10.6669 5.33332 9.473 5.33332 8.00024C5.33332 6.52748 6.52723 5.33357 7.99999 5.33357C9.47275 5.33357 10.6667 6.52748 10.6667 8.00024Z",
    stroke: "#8897AE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15223_11922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtSign);
export default __webpack_public_path__ + "static/media/at-sign.944ed589f57827e95ab4332a72c8ed9c.svg";
export { ForwardRef as ReactComponent };